import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { ReactComponent as Chevron } from "assets/svg/chevronRight.svg";
import { Link } from "react-router-dom";

const Wrapper = styled(Link)`
  ${({ theme }) => theme.resFontSize.medium};
  align-items: center;
  color: ${({ theme }) => theme.palette.primary};

  border-radius: ${({ theme }) => theme.radius.small}px;
  background-color: ${({ theme }) => theme.palette.blue.lighter};
  border: none;

  &.unstyled {
    border-radius: 0;
    background-color: transparent;
  }

  display: flex;
  font-weight: bold;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacer * 1.5}px
    ${({ theme }) => theme.spacer * 2}px;
  width: 100%;

  > svg {
    height: 1.2rem;
    margin-left: 1em;
    flex-shrink: 0;
  }
`;

const StepButton = ({ className, label, to, unstyled }) => {
  const classes = ["StepButton"];
  if (className) classes.push(className);
  if (unstyled) classes.push("unstyled");

  return (
    <Wrapper to={to} className={classes.join(" ")}>
      <span className="label ellipsis">{label}</span>
      <Chevron />
    </Wrapper>
  );
};

StepButton.displayName = "StepButton";

StepButton.propTypes = {
  className: PropTypes.string,
  to: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  unstyled: PropTypes.bool,
};

StepButton.defaultProps = {
  className: null,
  unstyled: false,
};

export default StepButton;
